import React from "react";
import urls from "../../urls";
import { CURRENCY_CODE } from "../../constants/DeliveryConstants";

export const ProductStructuredData = (product) => {
  return (
    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "http://schema.org/",
        "@type": "Product",
        name: product.name,
        description: product.description,
        url: process.env.REACT_APP_WEBSITE_URL + urls.product + product.url,
        offers: {
          "@type": "Offer",
          priceCurrency: CURRENCY_CODE,
          price: product.price,
          priceSpecification: {
            "@type": "PriceSpecification",
            priceCurrency: CURRENCY_CODE,
            price: product.price,
          },
          availability:
            product.stock > 0
              ? "http://schema.org/InStock"
              : "http://schema.org/OutOfStock",
          url: process.env.REACT_APP_WEBSITE_URL + urls.product + product.url,
        },
        image: !!product.image ? product.image[0] : "",
      })}
    </script>
  );
};
